/**
 * Custom parameter type identifiers used by specialized property editors.
 * These values are exposed through parameter metadata as `typeCustom`.
 */
export class ParameterTypes {
	public static readonly IconName = 'ui:IconName';
	public static readonly FileId = 'file:FileId';
	public static readonly Color = 'ui:Color';
	public static readonly AgentId = 'agent:AgentId';
	public static readonly CronExpression = 'ui:CronExpression';
	public static readonly EnvironmentIds = 'ui:EnvironmentIds';
	public static readonly EnumRef = 'EnumRef';
	public static readonly ContentTemplateId = 'content:TemplateId';
	public static readonly TableColumns = 'ui:TableColumns';
	public static readonly TabsItems = 'ui:TabsItems';
	public static readonly DataDisplayProperty = 'DataDisplayProperty';
	public static readonly Actions = 'ui:Actions';
	public static readonly ViewId = 'ui:ViewId';
	public static readonly ViewMenu = 'ui:ViewMenu';
	public static readonly ViewDialog = 'ui:ViewDialog';
	public static readonly Layout = 'ui:Layout';
	public static readonly StringMap = 'StringMap';
}
